import withLoading from '@oncolens/oncolens-ui/lib/components/Common/withLoading';
import { SectionTitle } from '@/components/Layout/SectionTitle';
import { DiseaseDto } from '@/features/requests/components/NewRequest/Templates/osu/dtos/Disease';
import React from 'react';
import { isBreastOrOvarian } from '../../components/NewRequest/Templates/osu/domain/PatientHistory';

interface PatientHistoryProps {
  disease: DiseaseDto | undefined;
}

export const PatientHistory = ({ disease }: PatientHistoryProps) => {
  return (
    <div className="print:hidden">
      <SectionTitle title="Patient History" />
      <PatientHistoryBodyWithLoading isLoading={!disease} disease={disease} />
    </div>
  );
};

const PatientHistoryBody = ({ disease }: PatientHistoryProps) => {
  return (
    <div className="flex mb-4">
      <dl className="flex-1 mx-3">
        <div className="mt-5">
          <dt className="inline mr-1 font-bold">Chief Complaint</dt>
          <dd data-cy="chief-complaint">{disease?.chiefComplaint}</dd>
        </div>
        <div className="mt-10">
          <dt className="inline mr-1 font-bold">Medical History</dt>
          <dd data-cy="medical-history">{disease?.medicalHistory}</dd>
        </div>
        <div className="mt-10">
          <dt className="inline mr-1 font-bold">Social History</dt>
          <dd data-cy="social-history">{disease?.socialHistory}</dd>
        </div>
        <div className="mt-10">
          <dt className="inline mr-1 font-bold">Family History</dt>
          <dd data-cy="family-history">{disease?.familyHistory}</dd>
        </div>
        {isBreastOrOvarian(disease?.cancerTypeId || '') && (
          <>
            {disease?.breastOvarianCancerNear != null && (
              <div className="mt-10">
                <dt className="inline mr-1 font-bold">
                  Breast or Ovarian Cancer in 1st or 2nd Degree Relative?
                </dt>
                <dd data-cy="breast-or-ovarian-cancer-near">
                  {disease?.breastOvarianCancerNear ? 'Yes' : 'No'}
                </dd>
              </div>
            )}
            {disease?.menopausalStatus && (
              <div className="mt-10">
                <dt className="inline mr-1 font-bold">Menopausal Status</dt>
                <dd data-cy="menopausal-status">{disease?.menopausalStatus}</dd>
              </div>
            )}
          </>
        )}
        <div className="mt-10">
          <dt className="inline mr-1 font-bold">Miscellaneous Case Details</dt>
          <dd data-cy="misc-case-details">{disease?.miscellaneousCaseDetails}</dd>
        </div>
      </dl>
    </div>
  );
};

const PatientHistorySkeleton = () => (
  <div className="flex mb-4">
    <dl className="flex-1 mx-3">
      <div className="py-0.5">
        <dt className="block h-5 bg-gray-300 rounded-lg w-28 animate-pulse"></dt>
      </div>
      <div className="py-0.5">
        <dt className="block h-5 bg-gray-300 rounded-lg w-36 animate-pulse"></dt>
      </div>
      <div className="py-0.5">
        <dt className="block h-5 bg-gray-300 rounded-lg w-28 animate-pulse"></dt>
      </div>
      <div className="py-0.5">
        <dt className="block h-5 bg-gray-300 rounded-lg w-28 animate-pulse"></dt>
      </div>
      <div className="py-0.5">
        <dt className="block h-5 bg-gray-300 rounded-lg w-28 animate-pulse"></dt>
      </div>
      <div className="py-0.5">
        <dt className="block h-5 bg-gray-300 rounded-lg w-28 animate-pulse"></dt>
      </div>
    </dl>
  </div>
);

const PatientHistoryBodyWithLoading = withLoading(PatientHistoryBody, PatientHistorySkeleton);
